// chatbot-core.js
// UI + behavior only. No session is created on open; logging happens only on non-empty messages.

document.addEventListener("DOMContentLoaded", function() {
  // DOM elements
  const chatToggle = document.getElementById("chat-toggle");
  const chatbot = document.getElementById("chatbot");
  const chatToggleIcon = document.getElementById("chat-toggle-icon");
  const chatWindow = document.getElementById("chat-window");
  const userInputEl = document.getElementById("user-input");
  const endChatButton = document.getElementById("end-chat-button");
  const sendBtn = document.getElementById("send-button");

  let chatOpen = false;

  // Initialize chat history from localStorage (or start with an empty array)
  let chatHistory = [];
  if (localStorage.getItem("chatHistory")) {
    try {
      chatHistory = JSON.parse(localStorage.getItem("chatHistory")) || [];
    } catch (e) {
      chatHistory = [];
    }
  }

  function updateChatHistory() {
    localStorage.setItem("chatHistory", JSON.stringify(chatHistory));
  }

  function appendMessage(role, content, save = true) {
    // ignore blank messages at the UI layer, too
    const text = (content ?? "").trim();
    if (!text) return;

    const p = document.createElement("p");
    p.className = role === "user" ? "user-message fade-in" : "bot-message fade-in";
    p.innerHTML = text; // content is already your HTML/text; keep as-is per your current code
    if (role === "user") {
      p.style.marginLeft = "auto";
    } else {
      p.style.marginRight = "auto";
    }
    chatWindow.appendChild(p);
    if (save) {
      chatHistory.push({ role, content: text });
      updateChatHistory();
    }
    chatWindow.scrollTop = chatWindow.scrollHeight;
  }

  function renderChatHistory() {
    chatWindow.innerHTML = "";
    if (chatHistory.length === 0) {
      chatWindow.innerHTML = `<p class="bot-message fade-in"><em>Welcome! How can we help you today?</em></p>`;
    } else {
      chatHistory.forEach(m => appendMessage(m.role, m.content, false));
    }
  }

  // Toggle open/closed (no Firebase writes here)
  chatToggle.addEventListener("click", function (event) {
    if (chatOpen) {
      chatbot.classList.remove("open");
      setTimeout(() => {
        chatbot.style.display = "none";
        document.body.style.overflow = "auto";
      }, 300);
      if (chatToggleIcon) {
        chatToggleIcon.innerHTML = `<path d="M20 2H4a2 2 0 0 0-2 2v14l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>`;
      }
      chatOpen = false;
    } else {
      chatbot.style.display = "flex";
      setTimeout(() => { chatbot.classList.add("open"); }, 10);
      if (userInputEl) userInputEl.focus();
      renderChatHistory();
      if (chatToggleIcon) {
        chatToggleIcon.innerHTML = `<line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>`;
      }
      chatOpen = true;

      // IMPORTANT: do NOT create a session here
      // (We removed the old window.startSession() call)
    }

    // Prevent the event from affecting elements below
    if (event) event.stopPropagation();
  });

  // Detect clicks outside the chatbot to close it on mobile
  document.addEventListener('click', function(event) {
    if (!chatOpen) return;
    if (!chatbot.contains(event.target) && event.target !== chatToggle) {
      chatbot.classList.remove("open");
      setTimeout(() => { chatbot.style.display = "none"; }, 300);
      if (chatToggleIcon) {
        chatToggleIcon.innerHTML = `<path d="M20 2H4a2 2 0 0 0-2 2v14l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>`;
      }
      chatOpen = false;
    }
  });

  // End Chat prompt
  function appendClosingMessage() {
    if (document.querySelector(".closing-message")) return;
    const container = document.createElement("div");
    container.className = "closing-message fade-in";
    container.style.borderTop = "none";
    const question = document.createElement("p");
    question.innerHTML = "Did we answer your questions?";
    container.appendChild(question);

    const yesBtn = document.createElement("button");
    yesBtn.className = "yes-button";
    yesBtn.textContent = "Yes";
    container.appendChild(yesBtn);

    const noBtn = document.createElement("button");
    noBtn.className = "no-button";
    noBtn.textContent = "No";
    container.appendChild(noBtn);

    chatWindow.appendChild(container);
    chatWindow.scrollTop = chatWindow.scrollHeight;

    yesBtn.addEventListener("click", resetChat);
    noBtn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      showContactMessage();
      return false;
    });
  }

  function resetChat() {
    chatHistory = [];
    localStorage.removeItem("chatHistory");
    chatWindow.innerHTML = `<p class="bot-message fade-in"><em>Welcome! How can we help you today?</em></p>`;
    const closingPrompt = document.querySelector(".closing-message");
    if (closingPrompt) closingPrompt.remove();
  }

  function showContactMessage() {
    const closingPrompt = document.querySelector(".closing-message");
    if (closingPrompt) closingPrompt.remove();

    const contactInfo = `<em>Please email us at <a href="mailto:info@aquaquestwaterproof.com" class="support-link">info@aquaquestwaterproof.com</a> or call Toll Free: 1-844-775-7770 (USA/Canada) or International: +1-250-871-8011 so we can help further.</em>`;
    appendMessage("bot", contactInfo);

    setTimeout(() => {
      if (chatbot && chatbot.classList) {
        chatbot.classList.add("open");
        chatWindow.scrollTop = chatWindow.scrollHeight;
      }
    }, 100);
  }

  // Auto-expand the textarea
  if (userInputEl) {
    userInputEl.addEventListener("input", function () {
      this.style.height = "auto";
      const minHeight = 60;
      const maxHeight = 80;
      let newHeight = Math.max(this.scrollHeight, minHeight);
      if (newHeight > maxHeight) {
        newHeight = maxHeight;
        this.style.overflowY = "auto";
      } else {
        this.style.overflowY = "hidden";
      }
      this.style.height = newHeight + "px";
    });

    // Send on Enter (no shift)
    userInputEl.addEventListener("keypress", function (event) {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        sendMessage();
      }
    });
  }

  if (sendBtn) {
    sendBtn.addEventListener("click", sendMessage);
  }

  if (endChatButton) {
    endChatButton.addEventListener("click", function(event) {
      event.preventDefault();
      appendClosingMessage();
    });
  } else {
    // It's optional; your CSS references it but it's not always in DOM
    // console.warn("End Chat element not found.");
  }

  async function sendMessage() {
    const userInput = (userInputEl?.value || "").trim();
    if (!userInput) return;

    // 1) Show user message in UI
    appendMessage("user", userInput);

    // 2) Log user message; this will create a session if it's the first real message
    if (window.logInteraction) {
      try { await window.logInteraction("user", userInput); } catch (e) { console.error("logInteraction user failed:", e); }
    }

    // Reset input UI
    if (userInputEl) {
      userInputEl.value = "";
      userInputEl.style.height = "60px";
      userInputEl.style.overflowY = "hidden";
    }

    // Typing dots
    const thinkingElem = document.createElement("div");
    thinkingElem.className = "thinking-indicator fade-in";
    thinkingElem.innerHTML = `<div class="three-dots">
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                              </div>`;
    chatWindow.appendChild(thinkingElem);
    chatWindow.scrollTop = chatWindow.scrollHeight;

    // 3) Call your reply endpoint
    try {
      const response = await fetch('https://chatassistanthttp-abk3iaaida-uc.a.run.app', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: userInput })
      });

      const responseText = await response.text(); // for resilience + logging
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (e) {
        throw new Error(`Failed to parse JSON: ${responseText}`);
      }

      thinkingElem.remove();

      const botResponse = (result && result.message) ? String(result.message) : "Sorry, I didn't catch that.";
      appendMessage("bot", botResponse);

      // 4) Log bot reply (same session)
      if (window.logInteraction && botResponse.trim()) {
        try { await window.logInteraction("bot", botResponse); } catch (e) { console.error("logInteraction bot failed:", e); }
      }

    } catch (error) {
      console.error("Reply error:", error);
      thinkingElem.remove();
      appendMessage("bot", "Sorry, something went wrong. Please try again later.");
    }

    chatWindow.scrollTop = chatWindow.scrollHeight;
  }

  // Touch/mobile helpers
  chatToggle.addEventListener('touchend', function(e) {
    e.preventDefault();
    this.click();
  });

  chatbot.addEventListener('touchmove', function(e) {
    e.stopPropagation();
  });
});
